import { render, staticRenderFns } from "./ComponentBlock.vue?vue&type=template&id=6f89a117&"
import script from "./ComponentBlock.vue?vue&type=script&lang=js&"
export * from "./ComponentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports